import { getSignedParams, getPhpNow, getUdid } from '@/utils';
import {
  getWxPayUrl,
  getConfig,
  init,
  login,
  loginMobile,
  guestLogin,
  autoLogin,
  phoneRegister,
  bindPhone,
  forgetPassword,
  role,
  certification
} from '@/api/channelServer';
import { channelServerConfig } from '@/config';
import server from './index';
import mixServer from './mixServer';
import cookies from '@/cookies';
import { Dialog } from 'vant';
import store from '../store';

const channelServer = {
  // 配置接口返回结果
  configData: {},
  // 初始化返回结果
  initData: {},
  force_cert_status: '',
  // 乐牛SDK的秘钥
  app_key: '',
  // 乐牛access_token
  access_token: '',
  // 乐牛uid
  ln_uid: '',
  accountStorage: [],
  getWxPayUrl(params) {
    return new Promise(resolve => {
      getWxPayUrl(params).then(res => {
        resolve(res);
      });
    });
  },
  getConfig() {
    const params = {
      appid: mixServer.ln_appid,
      time: getPhpNow()
    };
    console.log(params)
    const signedParams = getSignedParams(channelServerConfig.app_key, params);
    return getConfig(signedParams).then(res => {
      const { data = {} } = res;
      this.configData = data;
      const app_key = data.app_key || '';
      this.app_key = app_key;
      channelServerConfig.api_app_key = app_key;
      return res;
    });
  },
  init() {
    return new Promise((resolve, reject) => {
      // 获取浏览器唯一标识
      getUdid()
        .then(udid => {
          const params = {
            appid: mixServer.ln_appid,
            time: getPhpNow(),
            ver: server.ver,
            udid: udid,
            uuid: udid,
            ...server.shareParams
          };
          console.log(params)
          const signedParams = getSignedParams(this.app_key, params);
          init(signedParams)
            .then(res => {
              const { data = {} } = res;
              this.initData = data;
              const access_token = data.access_token || '';
              this.access_token = access_token;
              channelServerConfig.access_token = access_token;
              store.commit('SET_PROURL', data.protocal_url && data.protocal_url.replace('http', 'https'));
              resolve(res);
            })
            .catch(error => {
              console.error('乐牛SDK初始化失败:', error);
              reject(error);
            });
        })
        .catch(error => {
          console.error('获取浏览器唯一标识错误:', error);
          reject(error);
        });
    });
  },
  // 渠道登录
  login(params) {
    return new Promise((resolve, reject) => {
      login(params).then(({ ret, msg, data = {} }) => {
        if (ret == 0) {
          const passwd = atob(data.passwd || '');
          this.ln_uid = data.uid; // 用在红包参数
          // token存到cookie(为了绑定账号的时候使用，区分于游客token)
          cookies.setItem('ln_h5sdk_user_token', data.token, 3600 * 24 * 30);
          cookies.setItem('ln_h5sdk_user_name', data.account, 3600 * 24 * 30);
          // 用户账密数据存到store
          store.commit('SET_USER', { ...data, passwd });
          console.log(data);
          this.isAntiAddiction = data.is_anti_addiction;
          // 新用户注册账号并成功登录后（或者首次游客登录后），不弹出实名制弹窗(9.28需求)
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
               // 当current_time 大于 expire_time时，该实名窗口不可关闭，否则可关闭
               // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert,  cert_msg: data.cert_msg}
                })
                store.commit('SET_ISCERTNAME', false);
                // store.commit('SHOW', {
                //   name: 'Certification',
                //   params: { cert_msg: data.cert_msg, is_close: false }
                // })

            } else {
              let accStorage = localStorage.getItem('firloginarr') || [];
              if (!accStorage.includes(data.account)) {
                this.accountStorage.push(data.account);
                localStorage.setItem('firloginarr', JSON.stringify(this.accountStorage));
                Dialog({ message: '您的实名信息已存在于本平台的账号实名库，可正常登录游戏进行体验' });
              }
              store.commit('CLOSE');
              localStorage.setItem('agreeProt', true);
              store.commit('SET_ISCERTNAME', true);
            }
          } else {
            store.commit('CLOSE');
            localStorage.setItem('agreeProt', true);
          }
          const params = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd
            })
          };
          resolve(params);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 手机验证码登录
  loginMobile(params) {
    return new Promise((resolve, reject) => {
      loginMobile(params).then(({ ret, msg, data = {} }) => {
        if (ret == 0) {
          const passwd = atob(data.passwd || '');
          this.ln_uid = data.uid; // 用在红包参数
          // token存到cookie(为了绑定账号的时候使用，区分于游客token)
          cookies.setItem('ln_h5sdk_user_token', data.token, 3600 * 24 * 30);
          cookies.setItem('ln_h5sdk_user_name', data.account, 3600 * 24 * 30);
          // 用户账密数据存到store
          store.commit('SET_USER', { ...data, passwd });
          console.log(data);
          this.isAntiAddiction = data.is_anti_addiction;
          // 新用户注册账号并成功登录后（或者首次游客登录后），不弹出实名制弹窗(9.28需求)
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
               // 当current_time 大于 expire_time时，该实名窗口不可关闭，否则可关闭
               // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert,  cert_msg: data.cert_msg}
                })
                store.commit('SET_ISCERTNAME', false);
                // store.commit('SHOW', {
                //   name: 'Certification',
                //   params: { cert_msg: data.cert_msg, is_close: false }
                // })

            } else {
              let accStorage = localStorage.getItem('firloginarr') || [];
              if (!accStorage.includes(data.account)) {
                this.accountStorage.push(data.account);
                localStorage.setItem('firloginarr', JSON.stringify(this.accountStorage));
                Dialog({ message: '您的实名信息已存在于本平台的账号实名库，可正常登录游戏进行体验' });
              }
              store.commit('CLOSE');
              localStorage.setItem('agreeProt', true);
              store.commit('SET_ISCERTNAME', true);
            }
          } else {
            store.commit('CLOSE');
            localStorage.setItem('agreeProt', true);
          }
          const params = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd
            })
          };
          resolve(params);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 游客登录
  guestLogin() {
    return new Promise((resolve, reject) => {
      const token = cookies.getItem('ln_h5sdk_guest_token');
      // if (token) {
      //   // 本地有TOKEN,直接登录
      //   this.autoLogin({ token });
      //   return;
      // }
      // 没有TOKEN，走登录接口
      guestLogin().then(({ ret, msg, data }) => {
        if (ret == 0) {
          // token存到cookie
          cookies.setItem('ln_h5sdk_guest_token', data.token, 3600 * 24 * 30);
          // this.autoLogin({ token: data.token });
          // 判断游客登录是否是否实名，若没实名就弹出实名弹窗,否则关闭弹窗
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
              if (data.current_time >= data.expire_time) { // 当current_time 大于等于 expire_time时，该实名窗口不可关闭，否则可关闭
                // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert,  cert_msg: data.cert_msg}
                });
                store.commit('SET_ISCERTNAME', false);
                // store.commit('SHOW', {
                //   name: 'Certification',
                //   params: { cert_msg: data.cert_msg, is_close: false }
                // })

              } else {
                // store.commit('CLOSE');
                store.commit('SET_ISCERTNAME', true);
              }
              // } else {
              //   store.commit('SHOW', {
              //     name: 'Certification',
              //     params: { cert_msg: data.cert_msg, is_close: true }
              //   })
              // }
            } else {
              // store.commit('CLOSE');
              store.commit('SET_ISCERTNAME', true);
            }
          } else {
            store.commit('SET_ISCERTNAME', true);
            // store.commit('CLOSE');
          }
          store.commit('SET_GUESTINFO', { guestAccount: data.account, guestPass: atob(data.passwd || '') });
          localStorage.setItem('lnUserAccount', data.account);
          localStorage.setItem('lnUserPass', atob(data.passwd || ''));
          resolve(data);
        } else {
          resolve(ret);
          Dialog({ message: msg });
        }
      });
    });
  },
  // 自动登录
  autoLogin(params) {
    return new Promise((resolve, reject) => {
      autoLogin(params).then(({ ret, msg, data }) => {
        // 用户账密数据存到store
        const passwd = atob(data.passwd || '');
        store.commit('SET_USER', { ...data, passwd });
        if (ret == 0) {
          const params = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd
            })
          };
          this.ln_uid = data.uid;
          // 判断游客登录是否是否实名，若没实名就关闭弹出实名弹窗,否则关闭弹窗
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
              if (data.current_time >= data.expire_time) { // 当current_time 大于等于 expire_time时，该实名窗口不可关闭，否则可关闭
                // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert,  cert_msg: data.cert_msg}
                })
                store.commit('SET_ISCERTNAME', false);
                // store.commit('SHOW', {
                //   name: 'Certification',
                //   params: { cert_msg: data.cert_msg, is_close: false }
                // })

              } else {
                store.commit('SET_ISCERTNAME', true);
                // store.commit('CLOSE');
              }
              // } else {
              //   store.commit('SHOW', {
              //     name: 'Certification',
              //     params: { cert_msg: data.cert_msg, is_close: true }
              //   })
              // }
            } else {
              store.commit('SET_ISCERTNAME', true);
              // store.commit('CLOSE');
            }
          } else {
            // store.commit('CLOSE');
          }
          // 自动登录后调用融合登录
          const mixLogin = mixServer.login(params);
          resolve(mixLogin);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 手机注册
  phoneRegister(params) {
    return new Promise((resolve, reject) => {
      phoneRegister(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve({ ret, msg, data });
        } else {
          // 注册失败
          Dialog({ message: msg });
        }
      });
    });
  },
  // 绑定手机
  bindPhone(params) {
    return new Promise((resolve, reject) => {
      bindPhone(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 忘记密码
  forgetPassword(params) {
    return new Promise((resolve, reject) => {
      forgetPassword(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 角色上报
  role(params) {
    return new Promise((resolve, reject) => {
      role(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 角色上报成功,不需反馈给游戏端
          resolve(data);
        } else {
          console.error('角色上报失败:' + msg);
        }
      });
    });
  },
  // 实名认证
  certification(params) {
    return new Promise((resolve, reject) => {
      certification(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 实名认证成功,不需反馈给游戏端
          resolve({ ret, msg, data });
        } else {
          Dialog({ message: msg });
        }
      });
    });
  }
};

export default channelServer;
